module.exports = __webpack_public_path__ + "statics/img/产品缺省图.f5252fa2.svg";